import { PrimaryMedicalHistoryFieldTypes } from '../types';

export const PRIMARY_MEDICAL_HISTORY_FIELD_DATA_KEYS: Record<PrimaryMedicalHistoryFieldTypes.OptionSetType, boolean> = {
  allergies: true,
  medications: true,
  disease: true,
};
